import { $amplitudeExperimentsAtom } from '@client/core/atoms/amplitude.js';
import { $config } from '@client/core/atoms/config.js';
import {
  DeviceType,
  DisplayPlacementId,
  ExperimentVariants,
  GamMediaType,
  type GamSize,
  type GamSizeMapping,
  type PlacementId,
  type SizeMediaType,
  Vertical
} from '@schibsted-nmp/advertising-shared';

const ALLOWED_PLACEMENTS = [
  DisplayPlacementId.AdvtMiddle2,
  DisplayPlacementId.AdvtMiddle3,
  DisplayPlacementId.AdvtMiddle4,
  DisplayPlacementId.AdvtMiddle5
];

export const getFinnExperimentSizeMappings = (
  mediaTypes: SizeMediaType[],
  placementId: PlacementId
): GamSizeMapping[] | null => {
  if (
    typeof window === 'undefined' ||
    !isDesktopSizeMappingExperimentApplicable(placementId)
  ) {
    return null;
  }

  const { experiments } = $amplitudeExperimentsAtom.get();
  const variant = experiments['advt-size-mapping-finn-desktop'];

  if (!variant || variant === ExperimentVariants.Control) {
    return null;
  }

  // Convert original mediaTypes to GamSize format for viewport >= 820px
  const originalSizes: GamSize[] = mediaTypes.reduce<GamSize[]>((sizes, mt) => {
    if (mt.type === GamMediaType.Native) {
      return [...sizes, 'fluid'];
    }
    if (mt.width && mt.height) {
      return [...sizes, [mt.width, mt.height]];
    }
    return sizes;
  }, []);

  // Experiment sizes for viewport < 820px
  const experimentSizes: GamSize[] = [
    [300, 250],
    [320, 250],
    [320, 400],
    'fluid'
  ];

  // Return size mappings: >= 820px uses original sizes, < 820px uses experiment sizes
  return [
    {
      breakpoint: [880, 0],
      sizes: originalSizes
    },
    {
      breakpoint: [0, 0],
      sizes: experimentSizes
    }
  ];
};

export const isDesktopRecommerce = (): boolean => {
  if (typeof window === 'undefined') return false;
  const config = $config.get();

  return (
    config?.deviceType === DeviceType.Desktop &&
    config.vertical === Vertical.Recommerce
  );
};

export const isDesktopSizeMappingExperimentApplicable = (
  placementId: PlacementId
): boolean => {
  if (!isDesktopRecommerce()) return false;

  return ALLOWED_PLACEMENTS.includes(placementId as DisplayPlacementId);
};
